"use client";
import React, { forwardRef } from "react";

import Link, { LinkProps } from "next/link";
import { usePathname } from "next/navigation";

type Props = {
  children: React.ReactNode;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  href: any;
} & LinkProps;

// The app's internal-link primitive. Navigation animations come from React's
// <ViewTransition> components around the linked content: App Router
// navigations are React transitions, which activate them automatically. The
// previous implementation wrapped router.push in document.startViewTransition
// on click - that legacy pattern raced next/link's own navigation (flaky or
// dropped navigations, reproducible in headless Chromium) and is superseded
// by React's built-in support.
const AnimatedLink = forwardRef<HTMLAnchorElement, Props>(
  ({ children, href, ...other }, ref) => {
    const pathname = usePathname();
    const isCurrentPage = (target: string) => {
      return pathname
        .replaceAll("/", "")
        .includes(target?.replaceAll("/", "") ?? "");
    };

    return (
      <Link
        aria-current={isCurrentPage(href) ? "page" : undefined}
        href={href || ""}
        passHref
        ref={ref}
        {...other}
      >
        {children}
      </Link>
    );
  },
);
export default AnimatedLink;
